// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__cXpZs","logo":"Navbar_logo__JuL0V","downloadButton":"Navbar_downloadButton__CzAc5","footerRight":"Navbar_footerRight__M4ej-"};